import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import addFileProviderToUserAccount from './addFileProviderToUserAccount';
import getProviderTypeFromAddProviderRedirectUrl from '../utils/getProviderTypeFromAddProviderRedirectUrl';
import { action } from 'satcheljs/lib/legacy';
import { clearAuthWindowInfo, getAuthWindowInfo } from './helpers/AuthWindowInfo';
import { parse } from 'querystring';

function getProviderTypeFromRedirectUrl(redirectUrl: string) {
    const queryStringStartIndex = redirectUrl.indexOf('?');
    const queryString =
        queryStringStartIndex !== -1 ? redirectUrl.slice(queryStringStartIndex + 1) : '';
    const queryStringValues = parse(queryString);
    const providerType = getProviderTypeFromAddProviderRedirectUrl(queryStringValues || {});

    return providerType;
}

export default action('addFileProviderAfterAuthFinished')(function addFileProviderAfterAuthFinished(
    redirectUrl: string
): Promise<void> {
    const providerType = getProviderTypeFromRedirectUrl(redirectUrl);
    if (!providerType) {
        throw new Error('Could not find the provider type');
    }

    const authWindowInfo = getAuthWindowInfo(providerType);
    return addFileProviderToUserAccount(
        redirectUrl,
        providerType,
        authWindowInfo.getAddableFileProviderInfo
    )
        .then((fileProvider: AttachmentDataProvider) => {
            clearAuthWindowInfo(providerType);
            authWindowInfo.onProviderAdded(fileProvider);
        })
        .catch(error => {
            clearAuthWindowInfo(providerType);
            authWindowInfo.onErrorAddingProvider(error);
        });
});
